export default function getUserDisplayName(user) {
  return (
    user?.userprofile?.display_name ||
    user?.display_name ||
    user?.username ||
    ''
  );
}
